<template>
  <div class="card referral-card mb-4 shadow-sm">
    <div class="card-body text-center d-flex flex-column align-items-center">
      <h5 style="padding-bottom: 5px;" class="card-title">{{ referral.serviceCenterName }}</h5>
      <plate :value="formattedRegNumber" class="mb-3" />

      <h5 class="card-title">{{ referral.customBrand + referral.customModel }}</h5>
      <br>
      <h6 style="padding-bottom: 5px;" class="card-subtitle text-muted">{{ referral.clientName }}</h6>
      <h6 style="padding-bottom: 5px;" class="card-subtitle text-muted">{{ referral.clientPhone }}</h6>
      <div style="margin-top: 5px;" class="d-flex justify-content-between w-100 align-items-center">
        <small class="text-muted">
          <i class="fa fa-calendar me-1"></i>{{ referral.referralDateStr }}
        </small>

        <referral-status :status="referral.status || 0" :statusName="referral.statusName || ''" tag="small" />


      </div>
    </div>
  </div>
</template>

<script>
import Plate from "./Plate.vue";

import ReferralStatus from "../components/ReferralStatus.vue";

export default {
  components: {
    Plate,
    ReferralStatus
  },
  props: {
    referral: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    formattedRegNumber() {
      if (!this.referral.regNumber) return "00-XX-000";
      return this.referral.regNumber.replace(/^(\d{2})([a-zA-Z]{2})(\d{3})$/, "$1-$2-$3");
    },
  },

};
</script>

<style scoped>
.referral-card {
  width: 269px;
  margin: auto;
  border-radius: 0.5rem;
  transition: transform 0.3s;
  text-align: center;
}

@media (max-width: 768px) {
  .referral-card {
    width: 300px;
  }
}

.referral-card:hover {
  transform: translateY(-5px);
}

.referrals-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  margin: 0 auto;
  padding: 16px;
  justify-content: center;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.badge {
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .referrals-container {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
  }
}
</style>
